import React, { Component } from 'react';
import Strings from 'localization/Strings';
import { MdLogout } from "react-icons/md";
import './NetlifyIdentityComponent.css'
import MyButton from 'components/MyButton/MyButton';

export const IDStatus = {  
  authenticated: 1,
  notSet: 0,
  expired: -1,
}; 

class NetlifyIdentityComponent extends Component {
    // netlifyIdentity = null;
    static tockenMargin = 1000 * 60 * 10; // 10 minutes
    constructor(props){
        super(props);
        this.state = {loged_in: false, user: null};
        this.netlifyIdentity = null;
        this.initNetlifyIdentity();
      }

    componentDidMount() {
      setTimeout(() => {
        this.refresh();
      }, 500);
    }

    render (){
      if (this.state.loged_in) {
        return (
          <div className='logoutText'>
            <span className='sub-heading1 username-block'> {this.state.user?.email} </span>
            <MyButton className="login-button" type="transparent" onClick={() => {this.tryLogOut(this.props?.onLogoutHandler)}}>
                <MdLogout />              
            </MyButton>
          </div>
          );
        }
      else {
        return (<></>);
      }
    }
  
    static hasAlreadyAdded = false;
    initNetlifyIdentity() {
      if(NetlifyIdentityComponent.hasAlreadyAdded) {
        return;
      }
      NetlifyIdentityComponent.hasAlreadyAdded = true;
      const script = document.createElement("script");
      script.src = "https://identity.netlify.com/v1/netlify-identity-widget.js";
      script.async = true;
      document.body.appendChild(script);
    }

    refresh(){
      const netlifyIdentity = window.netlifyIdentity;
      if (netlifyIdentity) {
        let user = this.currentUser();
        if (user) {
          this.setState({loged_in: true, user: user});
        }
        else {
          this.setState({loged_in: false, user: null});
        }
      }
    }
    refreshToken(onSucceedHandler, onFailedHandler){
      const netlifyIdentity = window.netlifyIdentity;
      if (netlifyIdentity) {
        netlifyIdentity.refresh().then(user => {
          if (this.authenticated() === IDStatus.authenticated) {
            // console.log("authentication is refreshed and now is valid!");
            onSucceedHandler();
          } else{
            // console.log("authentication is refreshed but not yet valid. so logged out!");
            this.tryLogOut(() => {
              onFailedHandler();
            });
          }
        });
      }
    }
  
    async tryLogIn(onLoginHandler){
      const netlifyIdentity = window.netlifyIdentity;

      if (netlifyIdentity) {
        this.netlifyIdentity = netlifyIdentity;
        this.netlifyIdentity.open();
        this.netlifyIdentity.on("init", user => this.refresh());
        this.netlifyIdentity.on("login", user => {
          onLoginHandler();
          this.refresh();
        });
        this.netlifyIdentity.on("logout", () => this.refresh());
        this.netlifyIdentity.on("error", err => this.refresh());
        this.netlifyIdentity.on("open", () => this.refresh());
        this.netlifyIdentity.on("close", () => this.refresh());
    }
      else {  
        // console.log("netlifyIdentity not defined");
      }
    }

    tryLogOut(onLogoutHandler){
      const netlifyIdentity = window.netlifyIdentity;
      netlifyIdentity.logout();
      if (onLogoutHandler !== null){
        netlifyIdentity.on("logout", () => {
          onLogoutHandler();
          this.refresh();
        });
      }
      this.refresh();
    }

    authenticated(){
      let currentUser = this.currentUser()
      if (currentUser == null) {
        return IDStatus.notSet;
      }
      // console.log("checking token... expired at: ", new Date(currentUser.token.expires_at).toTimeString());
      if (currentUser.token.expires_at > ( new Date().getTime() + NetlifyIdentityComponent.tockenMargin)){
        return IDStatus.authenticated;
      } else{
        return IDStatus.expired;
      }
    }

    currentUser(){
      const netlifyIdentity = window.netlifyIdentity;
        return netlifyIdentity?.currentUser();
    }
  }

export default NetlifyIdentityComponent;